import { ORDER_OF_ASSETS } from 'services/ProductFormService'

export const capitalizeFirstLetter = (str: string): string => {
  if (str) {
    return str[0].toUpperCase() + str.slice(1).toLowerCase()
  } else {
    return ''
  }
}

export const capitalizeEveryLetter = (str: string): string => {
  if (str) {
    return str
      .split(' ')
      .map(word => word[0].toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  } else {
    return ''
  }
}

export const createIdForCypress = (...strings: string[]) => {
  let id = ''

  for (let i = 0; i < strings.length; i++) {
    if (i === 0) {
      id += strings[i]
    } else {
      id += ' ' + strings[i]
    }
  }

  return id.split('/').join('').split(' ').join('-').toLowerCase()
}

export const prepareAddProductFormValues = (key: string): string => {
  //@sieradz - from first_lead to First Lead (as API wants)
  if (ORDER_OF_ASSETS.includes(key)) {
    const tempValue = key.replace('_', ' ')

    return capitalizeEveryLetter(tempValue)
  } else {
    return key
  }
}

export const transformObjectKeys = (obj: Record<string, any>) => {
  // Create a new object to store the transformed keys and values
  if (obj && typeof obj === 'object') {
    const transformedObject: Record<string, any> = {}

    // Iterate over each key-value pair in the original object
    Object.entries(obj).forEach(([key, value]) => {
      // Replace spaces with underscores and convert to lowercase
      const transformedKey = key.replace(/\s+/g, '_').toLowerCase()

      // Assign the value to the transformed key in the new object
      transformedObject[transformedKey] = value
    })

    // Return the new object with transformed keys
    return transformedObject
  }

  return obj
}

export const formatAssetName = (name: string) => {
  if (!name) return ''

  return name.replace(/\s+/g, '_').toLowerCase()
}

/**
 * Extracts YouTube video ID from a URL or returns the string as-is if it's already an ID (11 chars, alphanumeric + -_).
 * Handles: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/embed/ID.
 */
export const extractYoutubeId = (value: string | undefined | null): string => {
  if (value == null || typeof value !== 'string') return ''
  const trimmed = value.trim()

  if (!trimmed) return ''
  const watchMatch = trimmed.match(/(?:youtube\.com\/watch\?v=)([a-zA-Z0-9_-]{11})/)

  if (watchMatch) return watchMatch[1]
  const shortMatch = trimmed.match(/(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/)

  if (shortMatch) return shortMatch[1]
  const embedMatch = trimmed.match(/(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/)

  if (embedMatch) return embedMatch[1]
  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) return trimmed

  return trimmed
}
